<template>
    <div class="top-shows">
        <h3 class="widget-title">
            {{ computedTitle }}
        </h3>
        <data-loader :data="shows">
            <div class="labels">
                <span>Podcast Name</span>
                <span>Listens</span>
            </div>

            <ul class="shows-list">
                <li
                    v-for="show in shows"
                    :key="show.hash"
                    :class="['show', { 'not-hosted': !show.hosted }]"
                >
                    <base-show-image :show="show" />

                    <div class="show-description">
                        <h4 class="show-name">
                            {{ show.title }}
                        </h4>
                        <div class="show-meta">
                            <show-label
                                class="show-labels"
                                :item="show"
                            />
                        </div>
                    </div>

                    <p v-if="show.hosted && show.totalListens" class="listens">
                        {{ format(show.totalListens) }}
                    </p>
                </li>
            </ul>
        </data-loader>
    </div>
</template>

<script>

/**
 * External dependencies
 */
import { mapActions, mapState } from 'vuex';

/**
 * Internal dependencies
 */
import analyticsData from '@/mixins/analyticsData';
import DataLoader from '@/components/DataLoader';
import ShowLabel from '@/components/Shows/ShowLabel';
import format from '@/utils/numberFormat';

export default {
    components: {
        DataLoader,
        ShowLabel,
    },

    mixins: [
        analyticsData,
    ],

    props: {
        from: {
            type: String,
            default: null,
        },
        limit: {
            type: Number,
            default: 5,
        },
        title: {
            type: String,
            default: null,
        },
        to: {
            type: String,
            default: null,
        },
    },

    computed: {
        ...mapState({
            allShows: 'shows',
            analyticsData: 'topShows',
        }),

        /**
         * Returns top episodes.
         *
         * @returns {Array|null} Top episodes.
         */
        shows() {
            const data = this.analyticsData?.[this.key];

            if (! data || ! this.allShows) {
                return data;
            }

            const shows = data.map(({ show, totalListens }) => ({
                ...show,
                totalListens,
            }));

            if (data.length < this.limit && this.allShows) {
                return [
                    ...shows,
                    ...Object.values(this.allShows)
                        .filter(show => ! show.hosted)
                        .slice(0, this.limit - data.length),
                ];
            }

            return shows;
        },

        /**
         * Returns section title.
         *
         * @returns {string} Section title.
         */
        computedTitle() {
            return this.title || `Top ${this.limit} Shows`;
        },

    },

    watch: {
        /**
         * Sets limit as analiticsDataParams item.
         *
         * @returns {void}
         */
        limit() {
            this.analiticsDataParams = { limit: this.limit };
        },
    },

    methods: {
        ...mapActions({
            loadData: 'loadTopShows',
        }),

        format,
    },
};
</script>
